var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCamera = function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3287 4C22.804 4 24 5.19598 24 6.6713V17.3287C24 18.804 22.804 20 21.3287 20H2.6713C1.19598 20 0 18.804 0 17.3287V6.6713C0 5.19598 1.19598 4 2.6713 4H21.3287ZM12 6.66667C9.05448 6.66667 6.66667 9.05448 6.66667 12C6.66667 14.9455 9.05448 17.3333 12 17.3333C14.9455 17.3333 17.3333 14.9455 17.3333 12C17.3333 9.05448 14.9455 6.66667 12 6.66667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 9.33333C13.4728 9.33333 14.6667 10.5272 14.6667 12C14.6667 13.4728 13.4728 14.6667 12 14.6667C10.5272 14.6667 9.33333 13.4728 9.33333 12C9.33333 10.5272 10.5272 9.33333 12 9.33333ZM14.6667 0C15.403 0 16 0.596953 16 1.33333C16 2.06971 15.403 2.66667 14.6667 2.66667H9.33333C8.59695 2.66667 8 2.06971 8 1.33333C8 0.596953 8.59695 0 9.33333 0H14.6667Z",
    fill: "#DEE2E6"
  })));
};
export default SvgCamera;